import PropTypes from 'prop-types'
import { Box, Button } from '@mui/material'

import SplitButton from '../../../ui/components/splitButton'
import useStyles from '../styles'

const Actions = ({ actionsOptions }) => {
  const classes = useStyles()

  return (
    <Box className={classes.actions}>
      {actionsOptions?.length > 1 ? (
        <SplitButton size="medium" options={actionsOptions} />
      ) : (
        <Button onClick={actionsOptions[0].onClick}>
          {actionsOptions[0].text}
        </Button>
      )}
    </Box>
  )
}

Actions.propTypes = {
  actionsOptions: PropTypes.array,
}

export default Actions
